import React, { Component } from "react";
import {
  Tabs,
  TabList,
  Tab,
  DragTab,
  PanelList,
  Panel,
  ExtraButton,
} from "react-tabtab";
import * as customStyle from "react-tabtab/lib/themes/material-design";
import Overview from "./Overview";
import Courses from "./Courses";
import Assignment from "./Assignment";
import Certification from "./Certification";
import Badges from "./Badges";
import TimeLine from "./TimeLine";

export default class SpecificReport extends Component {
  render() {
    return (
      <div>
        <div class="form-group row">
          <div class="col-12">
            <Tabs customStyle={customStyle}>
              <TabList>
                <Tab>
                  <i class="fas fa-sliders-h"></i> Overview
                </Tab>
                <Tab>
                  <i class="fas fa-users"></i> Courses
                </Tab>
                <Tab>
                  <i class="fas fa-palette"></i> Assignment
                </Tab>
                <Tab>
                  <i class="fas fa-certificate"></i> Certifications
                </Tab>
                <Tab>
                  <i class="fas fa-gamepad"></i> Badges
                </Tab>
                <Tab>
                  <i class="fas fa-shopping-cart"></i> Timeline
                </Tab>
              </TabList>
              <PanelList>
                <Panel>
                  <Overview />
                </Panel>
                <Panel>
                  <Courses />
                </Panel>
                <Panel>
                  <Assignment />
                </Panel>
                <Panel>
                  <Certification />
                </Panel>
                <Panel>
                  <Badges />
                </Panel>
                <Panel>
                  <TimeLine />
                </Panel>
              </PanelList>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}
